import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import React, { useEffect, useMemo, useState } from "react";

const getRootCategories = (categories) =>
  (categories || [])
    .filter((category) => !category?.categoria_padre_id)
    .sort((left, right) =>
      String(left?.descripcion || "").localeCompare(String(right?.descripcion || ""))
    );

export default function OfferChapterDialog({
  open,
  setOpen,
  categories,
  chapter,
  onSave,
}) {
  const rootCategories = useMemo(() => getRootCategories(categories), [categories]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [title, setTitle] = useState("");
  const isEditing = Boolean(chapter?.capitulo_id);

  useEffect(() => {
    if (!open) return;

    const category = rootCategories.find(
      (item) => item?.id === chapter?.partida_categoria_id || item?.id === chapter?.partida_categoria?.id
    ) || null;

    setSelectedCategory(category);
    setTitle(chapter?.titulo ?? category?.descripcion ?? "");
  }, [open, chapter, rootCategories]);

  const handleCategoryChange = (_, category) => {
    setSelectedCategory(category);
    setTitle(category?.descripcion ?? "");
  };

  const handleSave = () => {
    if (!selectedCategory) return;

    onSave({
      partida_categoria_id: selectedCategory.id,
      titulo: title.trim() || null,
    });
  };

  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      open={open}
      onClose={() => setOpen(false)}
      aria-labelledby="offer-chapter-dialog-title"
      className="backdrop"
    >
      <DialogTitle id="offer-chapter-dialog-title">
        {isEditing ? "Editar capítulo" : "Nuevo capítulo"}
      </DialogTitle>
      <DialogContent>
        <Autocomplete
          value={selectedCategory}
          options={rootCategories}
          getOptionLabel={(option) => option?.descripcion || ""}
          getOptionSelected={(option, value) => option?.id === value?.id}
          onChange={handleCategoryChange}
          disabled={isEditing}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Categoría"
              margin="normal"
              variant="outlined"
              required
            />
          )}
        />
        <TextField
          autoFocus
          fullWidth
          label="Título del capítulo"
          helperText="Opcional. Si se deja vacío, se mostrará el nombre de la categoría."
          margin="normal"
          value={title}
          onChange={(event) => setTitle(event.target.value)}
          inputProps={{ maxLength: 200 }}
          variant="outlined"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setOpen(false)} variant="outlined">
          Cancelar
        </Button>
        <Button color="primary" disabled={!selectedCategory} onClick={handleSave} variant="contained">
          Guardar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
